let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aMdzs")).then(() => parcelRequire('joaA7'));